import { BaseMapData } from './BaseMapData.ts';
import { StoreMapType } from '../entity_datas/StoreEnums.ts';
import { StoreExpansionType, LobbyImage, MapSettingEnum, ModeSettingEnum, ScenarioSettingEnum } from '@colonist/types';
export class MapDataClassic4P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Classic4P, this.name = {
            key: 'strings:colonistCommon.gameMaps.classic.4P.title'
        }, this.image = LobbyImage.MapClassic4PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.isActive = true, this.numberOfLandTiles = 19, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataTutorialClassic4P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.TutorialClassic4P, this.name = {
            key: 'strings:colonistCommon.gameMaps.classic.tutorial4P.title'
        }, this.image = LobbyImage.MapClassic4PPreview, this.compatibleGameModes = [
            ModeSettingEnum.TutorialClassic4P,
            ModeSettingEnum.ServerStressTestClassic4P,
            ModeSettingEnum.BeginnerModeClassic4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 19, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataCampaignLevel1 extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.CampaignLevel1, this.name = {
            key: 'strings:colonistCommon.gameMaps.classic.tutorial4P.title'
        }, this.image = LobbyImage.MapClassic4PPreview, this.compatibleGameModes = [
            ModeSettingEnum.BeginnerModeClassic4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 19, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataCampaignLevel2 extends MapDataCampaignLevel1 {
    constructor(...args){
        super(...args), this.mapEnum = MapSettingEnum.CampaignLevel2;
    }
}
export class MapDataClassic4PRandom extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.Classic4PRandom
        ], this.mapEnum = MapSettingEnum.Classic4PRandom, this.name = {
            key: 'strings:colonistCommon.gameMaps.classic.random4P.title'
        }, this.image = LobbyImage.MapRandomBasePreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.isActive = true, this.numberOfLandTiles = 19, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataClassic56P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Classic56P,
            StoreExpansionType.CitiesAndKnights56P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Classic56P, this.name = {
            key: 'strings:colonistCommon.gameMaps.classic.56P.title'
        }, this.image = LobbyImage.MapClassic56PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 30, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataClassic78P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Classic78P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Classic78P, this.name = {
            key: 'strings:colonistCommon.gameMaps.classic.78P.title'
        }, this.image = LobbyImage.MapClassic78PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 37, this.scenario = ScenarioSettingEnum.None;
    }
}
